import React, { Component } from "react";
import Routes from "./Routes";

import ReactGA from 'react-ga';

import { getContentData } from "./apis/content";

import { Helmet } from "react-helmet";
import {Container} from 'reactstrap';

import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faStar)

ReactGA.initialize('UA-9907768-3');
ReactGA.pageview(window.location.pathname + window.location.search);


class App extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      contentData: null,
      isOpen: false
    };
  }

  componentDidMount() {
    getContentData('navigation',3)
      .then(contentData => this.setState({ contentData }))
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const contentData = this.state.contentData
    if (contentData) {
      console.log("APP-CONTENT: ", contentData)
    }
  
    return (
      <Container fluid id='App' className="p-0">
        <Helmet defaultTitle="Zuri Beauty" titleTemplate="Zuri Beauty - %s">
          <meta charset="utf-8"/>
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
          <meta name="theme-color" content="#4A99BF"/>
          <link rel="manifest" href="/manifest.json"/>
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
          <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32"/>
          <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16"/>
          <link rel="mask-icon" href="/safari-pinned-tab.svg"color="#5bbad5"/>
          <meta name="geo.region" content="GB-EDH" />
          <meta name="geo.placename" content="Edinburgh" />
          <meta name="geo.position" content="55.944754;-3.21766" />
          <meta name="ICBM" content="55.944754, -3.21766" />
          <meta name="author" content="Zuri Team"></meta>
          <link rel="canonical" href="https://zuri.co.uk"></link>
        </Helmet>
        <Navigation contentData={contentData} onClick={this.toggle} isOpen={this.state.isOpen}/>
        <Routes contentData={contentData}/>
        <Footer />
      </Container>
    );
  }
}

export default App;